import { render, staticRenderFns } from "./department-selector.vue?vue&type=template&id=d6a45bee&scoped=true&"
import script from "./department-selector.vue?vue&type=script&lang=js&"
export * from "./department-selector.vue?vue&type=script&lang=js&"
import style0 from "./department-selector.vue?vue&type=style&index=0&id=d6a45bee&prod&lang=scss&"
import style1 from "./department-selector.vue?vue&type=style&index=1&id=d6a45bee&prod&lang=scss&scoped=true&"
import style2 from "./department-selector.vue?vue&type=style&index=2&id=d6a45bee&prod&v-if=%24store.state.settings.layout%20%26%26%20%24store.state.settings.layout%20%3D%3D%20'secondary'&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a45bee",
  null
  
)

export default component.exports